import { MdError } from "react-icons/md";

export function Error({ label = "" }) {
  return (
    <div
      className="container d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <MdError size={25} />
      {label && <strong className="ms-2">{label}</strong>}
    </div>
  );
}
